module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    staticClass: "rounded-lg",
    attrs: {
      "outlined": ""
    }
  }, [_c('v-card-title', [_vm._v("Kontakte " + _vm._s(_vm.status))]), _vm._v(" "), _c('v-card-text', {
    staticClass: "pa-0"
  }, [(_vm.bbrbbr.length === 0) ? _c('div', {
    staticClass: "body-2 pa-4"
  }, [_vm._v("Kein " + _vm._s(_vm.status) + " eingetragen")]) : _vm._e(), _vm._v(" "), _c('v-simple-table', {
    attrs: {
      "dense": "",
      "fixed-header": ""
    }
  }, [_c('tbody', _vm._l((_vm.bbrbbr), function(item) {
    return _c('tr', {
      key: item.id,
      on: {
        "dblclick": function($event) {
          (_vm.bbr = item) && (_vm.showKontakt = true)
        }
      }
    }, [_c('td', [_vm._v(_vm._s(item.nachname) + ", " + _vm._s(item.vorname))]), _vm._v(" "), _c('td', {
      attrs: {
        "width": "20px"
      },
      on: {
        "click": function($event) {
          (_vm.bbr = item) && (_vm.showKontakt = true)
        }
      }
    }, [_c('v-icon', [_vm._v("info")])], 1)])
  }), 0)]), _vm._v(" "), _c('dialogKontakt', {
    attrs: {
      "visible": _vm.showKontakt,
      "bbr": _vm.bbr
    },
    on: {
      "update:visible": function($event) {
        _vm.showKontakt = $event
      },
      "close": function($event) {
        _vm.showKontakt = false
      }
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6e31df47"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/module_klein/kontakteStatus.vue
// module id = 789
// module chunks = 15